import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('DebitNoteService', DebitNoteService);

  DebitNoteService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'ModalWindowConfirmService',
    'WindowModalService',
  ];

  function DebitNoteService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    ModalWindowConfirmService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'debit_notes';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getDebitNotes: getDebitNotes,
      getDebitNote: getDebitNote,
      saveDebitNote: saveDebitNote,
      deleteDebitNote: deleteDebitNote,
      removeDebitNoteItems: removeDebitNoteItems,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      return {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };
    }

    function getDebitNotes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getDebitNote(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          // response
          // console.log(response.data.error);
          return false;
        }
      );
    }

    function saveDebitNote(debitNote) {
      // webhookEndPoint
      let method = 'post';
      let url = apiUrl;

      // let webhookUrl = ENV.apiEndpoint + webhookEndPoint;

      if (debitNote.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + debitNote.id;
      }

      function success(response) {
        let msg = debitNote.status === 'draft' ? 'DEBIT_NOTE_SAVED_AS_DRAFT' : 'DEBIT_NOTE_CREATED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { debit_note: debitNote }, success, failure); // , webhookUrl: webhookUrl
    }

    // Only for draft items
    function deleteDebitNote(debitNote, successCallback) {
      let url = apiUrl + '/' + debitNote.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: debitNote.company_id },
        function () {
          let params = {
            title: 'DELETE_DEBIT_NOTE',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'DEBIT_NOTE_DELETED',
            company_id: debitNote.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function removeDebitNoteItems(successCallback, cancelCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'CHANGE_CLIENT_FOR_CURRENT_DEBIT_NOTE',
        body: 'CHANGE_CLIENT_FOR_CURRENT_DEBIT_NOTE_WARNING',
      };

      var confirmCallback = function () {
        return successCallback();
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);
    }

    function openRelatedTransactions(transaction, client) {
      let templateUrl = './app/ajs/debit-notes/modals/debit-note-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          clientId: client.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
